import { useForm } from 'react-hook-form';
import {
  DeleteAgendaSlotRecurrenceFormValues,
  deleteAgendaSlotRecurrenceFormResolver,
} from './schema';

export type DeleteAgendaSlotRecurrenceUseForm = ReturnType<
  typeof useForm<DeleteAgendaSlotRecurrenceFormValues>
>;

export const useDeleteAgendaSlotRecurrenceForm = (
  defaultValues?: Partial<DeleteAgendaSlotRecurrenceFormValues>,
) => {
  const deleteAgendaSlotRecurrenceForm =
    useForm<DeleteAgendaSlotRecurrenceFormValues>({
      resolver: deleteAgendaSlotRecurrenceFormResolver,
      defaultValues: {
        mode: 'delete-occurrence',
        ...defaultValues,
      },
      // mode: 'all',
    });

  return { deleteAgendaSlotRecurrenceForm };
};
